import { render } from "./ContactClinicRouteButton.vue?vue&type=template&id=ea800214&ts=true"
import script from "./ContactClinicRouteButton.vue?vue&type=script&lang=ts"
export * from "./ContactClinicRouteButton.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__